// extracted by mini-css-extract-plugin
export default {"ticketWapper":"SmallTicket_ticketWapper__wofvy","ticketNumber":"SmallTicket_ticketNumber__CC9ji"};